import { Toaster as ChakraToaster, createToaster, Toast } from '@chakra-ui/react';

export const toaster: ReturnType<typeof createToaster> = createToaster({
  placement: 'top',
  pauseOnPageIdle: true,
});

export const Toaster = () => {
  return (
    <ChakraToaster toaster={toaster} width="500px">
      {(toast) => (
        <Toast.Root key={toast.id}>
          <Toast.Title>{toast.title}</Toast.Title>
          {toast.description && <Toast.Description>{toast.description}</Toast.Description>}
        </Toast.Root>
      )}
    </ChakraToaster>
  );
};
